import React, { useContext } from "react";
import { LabelContext } from "../../assets/js/labelDataContext";
import { StaticImage } from "gatsby-plugin-image"
import DietData from "../../assets/js/dietData";

const OrderDiet = (props) => {
  const val = useContext(LabelContext);
  const diet = val.labelInfo.diet;

  const btnDisabled = diet.length > 0;

  return (
    <div className="row">
      <div className="col-12">

        <form>
          <div className="diet-box">
            <h4>Wybierz dietę</h4>


            {DietData.map((dietItem, index) => (
              <div key={index}>
                <input
                  id={`diet-${index}`}
                  type="radio"
                  name="diet"
                  value={index}
                  onChange={val.handleChange("diet")}
                >
                </input>
                <label
                  className={`diet-option ${diet == index ? "is-active" : ""}`}
                  htmlFor={`diet-${index}`}
                >
                  {dietItem.title}
                </label>
              </div>
            ))}

            {/* <input
              id="optimal"
              type="radio"
              name="diet"
              value="1"
              onChange={val.handleChange("diet")}
            >
            </input>
            <label
              className={`diet-option ${diet == 1 ? "is-active" : ""}`}
              htmlFor="optimal"
            >
              Plan Optimal
            </label>

            <input
              id="sport"
              type="radio"
              name="diet"
              value="2"
              onChange={val.handleChange("diet")}
            >
            </input>
            <label
              className={`diet-option ${diet == 2 ? "is-active" : ""}`}
              htmlFor="sport"
            >
              Plan Sport
            </label>

            <input
              id="wege"
              type="radio"
              name="diet"
              value="3"
              onChange={val.handleChange("diet")}
            >
            </input>
            <label
              className={`diet-option ${diet == 3 ? "is-active" : ""}`}
              htmlFor="wege"
            >
              Plan Wege
            </label> */}

            <div
              variant="contained"
              color="primary"
              aria-label="text primary button group"
            >
              <button
                disabled={!btnDisabled}
                onClick={() => val.nextPage()}
                className="btn-next"
              >
                Dalej
              </button>
            </div>

          </div>
        </form>
      </div>
    </div>
  );
};
export default OrderDiet;

